
const privacyBody = `**1. Verantwortlicher für die Datenverarbeitung**

[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa]
E-Mail: bringylatam@gmail.com

**2. Welche Daten wir erheben**

Wenn Sie das Kontaktformular auf dieser Website nutzen, erheben wir folgende Daten: Name, E-Mail-Adresse, interessierte Route sowie Ihre Nachricht. Diese Daten sind erforderlich, um Ihnen antworten zu können.

Die Website kann technisch unbedingt erforderliche Cookies für den grundlegenden Betrieb speichern. Wir verwenden keine Tracking- oder Werbe-Cookies von Dritten.

**3. Zweck der Verarbeitung**

Die Formulardaten werden ausschließlich zur Bearbeitung Ihrer Anfrage und zur Verwaltung Ihrer ersten Registrierung auf der Plattform genutzt. Eine Weitergabe an Dritte erfolgt ohne Ihre Einwilligung nicht, außer bei gesetzlicher Verpflichtung.

**4. Rechtsgrundlage**

Die Verarbeitung basiert auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) beim Absenden des Formulars sowie auf berechtigtem Interesse an der Bearbeitung des vorvertraglichen Verhältnisses (Art. 6 Abs. 1 lit. b DSGVO).

**5. Speicherdauer**

Die Kontaktformular-Daten werden so lange aufbewahrt, wie dies zur Bearbeitung Ihrer Anfrage erforderlich ist und – maximal – bis zu 12 Monate nach dem letzten Kontakt, sofern kein anschließendes Vertragsverhältnis eine längere Aufbewahrung erfordert.

**6. Ihre Rechte**

Sie haben das Recht auf: Auskunft über Ihre personenbezogenen Daten, Berichtigung oder Löschung, Widerspruch gegen die Verarbeitung, Datenübertragbarkeit sowie Beschwerde bei der zuständigen Datenschutzaufsichtsbehörde.

Zur Ausübung Ihrer Rechte schreiben Sie uns an: bringylatam@gmail.com

**7. Hosting**

Diese Website wird bei Cloudflare gehostet. Cloudflare kann im Rahmen seines Netzwerk- und Sicherheitsdienstes technische Zugriffsdaten (IP-Adresse, Browser, Datum und Uhrzeit) verarbeiten. Weitere Informationen: https://www.cloudflare.com/privacypolicy/

**8. Änderungen dieser Erklärung**

Wir können diese Datenschutzerklärung jederzeit aktualisieren. Die jeweils gültige Fassung ist stets auf dieser Seite mit dem Datum der letzten Aktualisierung verfügbar.`

const impressumBody = `Angaben gemäß § 5 TMG / Información según § 5 TMG

**Verantwortlich:**
[COMPLETAR: Nombre completo del titular o razón social]
[COMPLETAR: Dirección completa — calle, número, código postal, ciudad, país]

**Kontakt:**
E-Mail: bringylatam@gmail.com
Telefon: [COMPLETAR: +49 ... o número correspondiente]

**Plattformbetreiber:**
Bringy
[COMPLETAR: misma dirección legal]

**Umsatzsteuer-ID / steuerliche Kennnummer (falls zutreffend):**
[COMPLETAR: DE... o número fiscal del país de registro]

**Haftungshinweis:**
Bringy handelt als intermediäre Plattform zwischen Käuferinnen und Reisenden. Wir sind nicht Vertragspartei bei Transaktionen zwischen Nutzern und übernehmen keine Haftung für die ausgetauschten Produkte, außer in den ausdrücklich in den Nutzungsbedingungen geregelten Fällen.

Die auf dieser Website bereitgestellten Informationen wurden sorgfältig zusammengestellt; dennoch übernehmen wir keine Gewähr für Richtigkeit, Vollständigkeit und Aktualität.

**Online-Streitbeilegung:**
Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr
Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.`

export const de = {
  brand: {
    name: 'Bringy',
    tagline: 'Echte Menschen. Echte Produkte. Verifizierte Routen.',
  },
  nav: {
    howItWorks: 'So funktioniert\'s',
    whyUs: 'Warum Bringy',
    offerings: 'Leistungen',
    faq: 'FAQ',
    contact: 'Kontakt',
    cta: 'Loslegen',
  },
  hero: {
    eyebrow: 'Europa ↔ Südamerika',
    titleAccent: 'Bring',
    titleRest: 'Was zählt.',
    subtitle:
      'Wir verbinden Menschen, die zwischen Europa und Südamerika reisen, mit denjenigen, die Produkte von der anderen Seite brauchen. Kein Kurier, keine Agentur — nur echte Menschen mit verifizierter Identität.',
    ctaBuscar: 'Produkt suchen',
    ctaOfrecer: 'Als Reisender anbieten',
    trustBadges: [
      { label: 'Identität verifiziert' },
      { label: 'Zahlung im Escrow' },
      { label: 'Öffentliche Reisenden-Bewertung' },
      { label: 'Dokumentierte Übergabe' },
    ],
    boardingPass: {
      passengerLabel: 'PASSAGIER',
      brand: 'BRINGY',
      sub: 'TRANSPORT · VERIFIZIERT · VERSICHERT',
      fromCode: 'BER',
      fromCity: 'BERLIN',
      toCode: 'EZE',
      toCity: 'BUENOS AIRES',
      flight: 'FLUG BR · 2026',
      gate: 'GATE A7',
    },
    coordsBerlin: '52.52°N · 13.40°E',
    coordsBuenosAires: '34.60°S · 58.38°W',
  },
  launchTrust: {
    id: 'lanzamiento',
    launchNote:
      'Bringy befindet sich in der Launch-Phase. Jeder neue Reisende wird persönlich von unserem Team verifiziert.',
    processTitle: 'Bevor ein Reisender auch nur einen einzigen Artikel transportiert',
    processIntro:
      'Wir zeigen die Strenge des Prozesses — keine erfundenen Testimonials. So schaffen wir Vertrauen vom ersten Tag an.',
    stepVerified: 'Verifiziert',
    stepPending: 'Ausstehend',
    processSteps: [
      {
        number: '01',
        title: 'Identitätsprüfung',
        description: 'Offizielle Dokumente werden vor Aktivität auf der Plattform validiert.',
      },
      {
        number: '02',
        title: 'Onboarding per Videocall',
        description: 'Erstes Gespräch mit unserem Team zu Regeln und Erwartungen.',
      },
      {
        number: '03',
        title: 'Escrow-Vereinbarung',
        description: 'Annahme der Bedingungen für geschützte Zahlungen vor der ersten Transaktion.',
      },
    ],
    foundingMembers: '{count} Reisende haben bereits ihre erste Route registriert',
  },
  whyUs: {
    id: 'por-que',
    sectionLabel: '02 · Warum Bringy',
    headline: 'Vier Garantien.',
    headlineAccent: 'Keine Ausnahmen.',
    title: 'Warum Bringy funktioniert',
    subtitle:
      'Informelle Lösungen gibt es bereits — WhatsApp-Gruppen, Kontakte von Kontakten. Bringy macht dasselbe, mit der fehlenden Infrastruktur.',
    cardAirline: 'BR · 2026',
    cardConfirmed: 'BESTÄTIGT',
    cardPending: 'AUSSTEHEND',
    cardApproved: '· GENEHMIGT ·',
    cardsMeta: [
      { value: 'IDENTITÄT', field: 'KYC · REISEPASS' },
      { value: 'VERSICHERUNG', field: 'BIS €4.000' },
      { value: 'COMPLIANCE', field: 'EU · AR · DEKLARIERT' },
      { value: 'LIEFERUNG', field: 'FOTO · TRACKING' },
    ],
    items: [
      {
        title: 'Überprüfbares Vertrauen',
        description:
          'Jeder Reisende durchläuft eine Identitätsprüfung, bevor er auf der Plattform aktiv ist. Sie wissen, mit wem Sie es zu tun haben.',
      },
      {
        title: 'Ihr Geld, geschützt',
        description:
          'Die Mittel bleiben im Escrow, bis Sie den Erhalt bestätigen. Kein Risiko, für etwas zu zahlen, das nicht ankommt.',
      },
      {
        title: 'Echte Reputation',
        description:
          'Jeder Reisende sammelt Lieferhistorie und Bewertungen. Sie sehen seine Bewertung vor der Koordination.',
      },
      {
        title: 'Dokumentierte Übergabe',
        description:
          'Für zusätzliche Sicherheit bieten wir Live-Verifizierung mit einem Bringy-Vertreter per Videocall.',
      },
    ],
  },
  services: {
    id: 'como-funciona',
    sectionLabel: '03 · So funktioniert\'s',
    headline: 'Eine Startbahn, kein',
    headlineAccent: 'ein Prozess.',
    tagline: 'Vier Schritte. Eine Atlantiküberquerung.',
    title: 'So funktioniert\'s',
    subtitle: '',
    footerLabels: { status: 'STATUS', eta: 'ETA', lane: 'SPUR' },
    stepMeta: [
      { status: 'WARTEN', eta: '~ 18H', lane: 'A7' },
      { status: 'WARTEN', eta: '~ 36H', lane: 'B8' },
      { status: 'WARTEN', eta: '~ 54H', lane: 'C9' },
      { status: 'WARTEN', eta: '~ 72H', lane: 'D10' },
    ],
    steps: [
      {
        number: 1,
        title: 'Anfrage veröffentlichen',
        description:
          'Beschreiben Sie das benötigte Produkt, das Ziel und Ihr Entgelt für den Transport.',
      },
      {
        number: 2,
        title: 'Ein Reisender übernimmt',
        description:
          'Verifizierte Reisende mit aktiven Routen sehen Ihre Anfrage und bieten an, sie auf der nächsten Reise mitzunehmen.',
      },
      {
        number: 3,
        title: 'Details abstimmen',
        description:
          'Sie vereinbaren Zahlungsart, Übergabeort und Zeiten direkt mit dem Reisenden im Plattform-Chat.',
      },
      {
        number: 4,
        title: 'Empfang und Bestätigung',
        description:
          'Sobald Sie das Produkt haben, bestätigen Sie die Übergabe und die Zahlung wird an den Reisenden freigegeben.',
      },
    ],
  },
  manifest: {
    sectionLabel: '04 · Heutiges Manifest',
    headline: 'Das Board,',
    headlineAccent: 'live.',
    tagline: 'Alle Sendungen deklariert.',
    liveLabel: 'Live · {count} Sendungen heute',
    columns: ['Zeit', 'Von → Nach', 'Sendung', 'Status', 'Flugsteig'],
    rows: [
      { time: '02:14', from: 'BER', to: 'EZE', carry: 'MEDIKAMENTE', status: 'VERSICHERT', gate: 'A07', statusKey: 'insured' },
      { time: '06:40', from: 'MAD', to: 'EZE', carry: 'ELEKTRONIK', status: 'VERIFIZIERT', gate: 'B12', statusKey: 'verified' },
      { time: '09:25', from: 'FCO', to: 'EZE', carry: 'SCHUHE', status: 'EINSTIEG', gate: 'C04', statusKey: 'boarding' },
      { time: '11:55', from: 'CDG', to: 'EZE', carry: 'DOKUMENTE', status: 'VERSICHERT', gate: 'D21', statusKey: 'insured' },
      { time: '14:30', from: 'LIS', to: 'EZE', carry: 'BÜCHER', status: 'GEMATCHT', gate: 'A03', statusKey: 'matched' },
    ],
    footerLeft: 'EU → AR · Manifest 2026',
    footerRight: 'Pre-Launch · Alle Routen verifiziert',
  },
  activeRoutes: {
    sectionLabel: '05 · Aktive Routen',
    headline: 'Europa fliegt ab.',
    headlineAccent: 'Buenos Aires wartet.',
    tagline: 'Fünf Korridore. Eine Richtung. Wir transportieren nur, was sowieso mitfliegt.',
    routePrefix: 'ROUTE',
    originLabel: 'Abflug',
    destLabel: 'Ziel',
    flightLabel: 'Flug',
    openLabel: 'Offen',
    routes: [
      { fromCity: 'Berlin',   fromCode: 'BER', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'Madrid',   fromCode: 'MAD', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h' },
      { fromCity: 'Rom',      fromCode: 'FCO', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 14h' },
      { fromCity: 'Paris',    fromCode: 'CDG', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 13h 30m' },
      { fromCity: 'Lissabon', fromCode: 'LIS', toCity: 'Buenos Aires', toCode: 'EZE', duration: '~ 12h 20m' },
    ],
  },
  offerings: {
    id: 'servicios',
    sectionLabel: '06 · Leistungen',
    title: 'Leistungen',
    buyer: {
      label: 'Für Käufer',
      title: 'Finden Sie, was nicht in Ihr Land kommt',
      body: 'Veröffentlichen Sie, was Sie brauchen, und verbinden Sie sich mit einem verifizierten Reisenden, der die Reise sowieso macht. Produkte zu Herkunftspreisen ohne Zwischenhändler.',
      cta: 'Anfrage veröffentlichen',
      products: [
        { name: 'iPhone 17 Pro · 256GB', price: '€ 980', route: 'Madrid → Buenos Aires', image: 'products/iPhone_17_Pro_Cosmic_Orange_PDP_Image_Position_1__DEDE-l.webp', imageAlt: 'iPhone 17 Pro' },
        { name: 'Nike Air Max 90', price: '€ 140', route: 'Berlin → Buenos Aires', image: 'products/nike.webp', imageAlt: 'Nike Air Max 90' },
        { name: 'PlayStation 5 Slim', price: '€ 480', route: 'Rom → Buenos Aires', image: 'products/sony-playstation-5-digital-edition-825-gb-wlan-schwarz-weiss.webp', imageAlt: 'PlayStation 5 Slim' },
        { name: 'Chanel Nº5 · 100ml', price: '€ 120', route: 'Paris → Buenos Aires', image: 'products/chanel-no-5-edp-vapo-200ml.png', imageAlt: 'Chanel Nº5' },
      ],
    },
    traveler: {
      label: 'Für Reisende',
      title: 'Verdienen Sie mit freiem Gepäckplatz',
      body: 'Sie reisen zwischen Europa und Südamerika? Veröffentlichen Sie Ihre Route und was Sie transportieren können. Reduzieren Sie Reisekosten und bauen Sie Reputation als vertrauenswürdiger Reisender auf.',
      cta: 'Als Reisender registrieren',
      routes: [
        { route: 'Berlin → Buenos Aires', activeTravelers: 'HQ · 3 aktive Reisende' },
        { route: 'Madrid → Buenos Aires', activeTravelers: '12 aktive Reisende' },
        { route: 'Rom → Buenos Aires', activeTravelers: '5 aktive Reisende' },
        { route: 'Paris → Buenos Aires', activeTravelers: '4 aktive Reisende' },
        { route: 'Lissabon → Buenos Aires', activeTravelers: '7 aktive Reisende' },
      ],
    },
  },
  faq: {
    id: 'faq',
    title: 'Häufig gestellte Fragen',
    subtitle: '',
    items: [
      {
        question: 'Wie registriere ich mich bei Bringy?',
        answer:
          'Füllen Sie das Formular mit Name, E-Mail und ob Sie kaufen oder reisen möchten. Wir melden uns innerhalb von 24 Stunden bei Ihnen und führen Sie durch die ersten Schritte.',
      },
      {
        question: 'Wer kann Reisender werden?',
        answer:
          'Jede Person ab 18 Jahren, die regelmäßig zwischen Europa und Südamerika reist. Vor der Veröffentlichung aktiver Routen ist eine Identitätsverifizierung erforderlich.',
      },
      {
        question: 'Woran erkenne ich, dass ich dem Reisenden vertrauen kann?',
        answer:
          'Jeder Reisende hat ein Profil mit Verifizierungsstufe, Lieferhistorie und Bewertungen anderer Nutzer. Mehr Historie bedeutet mehr Vertrauen.',
      },
      {
        question: 'Was passiert mit meinem Geld, wenn das Produkt nicht ankommt?',
        answer:
          'Die Mittel bleiben im Escrow bis zu Ihrer Empfangsbestätigung. Bei Problemen greift das Bringy-Team ein und vermittelt zwischen beiden Parteien.',
      },
      {
        question: 'Welche Produkte kann ich anfragen?',
        answer:
          'Jedes legale Produkt, das nach Zollbestimmungen des Ziellandes im Hand- oder Aufgabegepäck transportiert werden darf — z. B. Elektronik, Bekleidung, Kosmetik, haltbare Lebensmittel, Dokumente und mehr.',
      },
      {
        question: 'Wie viel berechnet Bringy?',
        answer:
          'Eine Provision von 8–10 % auf jede erfolgreiche Transaktion. Stammreisende können Pro für 9 €/Monat abonnieren — ohne Provision und mit mehr Sichtbarkeit.',
      },
      {
        question: 'Kann ich eine Übergabe mit Live-Verifizierung anfordern?',
        answer:
          'Ja. Bei höherem Wert oder auf Wunsch beider Parteien schaltet sich ein Bringy-Vertreter per Videocall ein, verifiziert Identitäten und dokumentiert den Austausch.',
      },
      {
        question: 'Welche Routen sind verfügbar?',
        answer:
          'Wir betreiben Routen von Berlin (HQ), Madrid, Rom, Paris und Lissabon — alle nach Buenos Aires. Weitere Routen je nach Nachfrage der Community.',
      },
      {
        question: 'Welche Zahlungsarten akzeptiert ihr?',
        answer:
          'Visa, Mastercard und Amex. Stripe für internationale Kartenzahlungen aus jedem Land. SEPA-Überweisungen in Europa. Mercado Pago in Südamerika. Auszahlung 1–2 Werktage nach Lieferbestätigung.',
      },
    ],
  },
  globe: {
    cities: ['Berlin ★', 'Madrid', 'Rom', 'Paris', 'Lissabon', 'Buenos Aires'],
  },
  contact: {
    id: 'contacto',
    title: 'Fragen oder Mitglied werden?',
    subtitle:
      'Wir befinden uns in der Launch-Phase und freuen uns auf Ihre Situation. Füllen Sie das Formular aus — das Team meldet sich innerhalb von 24 Stunden bei Ihnen.',
    emailLabel: 'Sie erreichen uns auch unter',
  },
  footer: {
    copyright: '© {year} Bringy. Alle Rechte vorbehalten.',
    tagline: 'Echte Menschen. Echte Produkte. Verifizierte Routen.',
    hubBerlin: 'Berlin',
    hubBuenosAires: 'Buenos Aires',
    links: {
      howItWorks: 'So funktioniert\'s',
      whyUs: 'Warum Bringy',
      offerings: 'Leistungen',
      faq: 'FAQ',
      contact: 'Kontakt',
      impressum: 'Impressum',
      privacy: 'Datenschutz',
    },
    social: {
      instagram: '@bringy',
      linkedin: 'linkedin.com/company/bringy',
      linkedinLabel: 'LinkedIn',
    },
    credits: {
      prefix: 'Erstellt von',
      studio: 'INKSKY independent studio',
    },
  },
  legal: {
    backHome: 'Zur Startseite',
    placeholderNotice: 'Mit [COMPLETAR] gekennzeichnete Felder bis zur rechtskräftigen Gründung der juristischen Person ausstehend.',
    privacy: {
      title: 'Datenschutzerklärung',
      body: privacyBody,
    },
    terms: {
      title: 'Nutzungsbedingungen',
      body: 'Bringy fungiert als intermediäre Plattform zwischen Käuferinnen und Reisenden. Die Nutzung setzt Einwilligung in Identitätsprüfung, Transport nur legaler Produkte und Streitschlichtung nach Plattformregeln voraus. Der endgültige Text wird noch veröffentlicht.',
    },
    impressum: {
      title: 'Impressum',
      body: impressumBody,
    },
  },
  a11y: {
    openMenu: 'Menü öffnen',
    closeMenu: 'Menü schließen',
    chooseLanguage: 'Sprache wählen',
  },
  forms: {
    backHome: 'Zur Startseite',
    submit: 'Anfrage senden',
    successTitle: 'Wir haben Ihre Anfrage erhalten!',
    successBody:
      'Wir melden uns in den nächsten 24 Stunden bei Ihnen, um Details abzustimmen. Willkommen bei Bringy.',
    fields: {
      name: { label: 'Vollständiger Name', placeholder: 'Ihr vollständiger Name' },
      email: { label: 'E-Mail', placeholder: 'sie@email.com' },
      role: {
        label: 'Ich bin …',
        placeholder: 'Bitte wählen',
        buyer: 'Käufer',
        traveler: 'Reisender',
      },
      countryRoute: {
        label: 'Interessante Route',
        placeholder: 'z. B.: Madrid → Buenos Aires',
        other: 'Andere Route',
      },
      message: {
        label: 'Produkt oder Nachricht',
        placeholder: 'Beschreiben Sie Ihr Produkt oder was Sie mitnehmen können',
        optional: 'Optional',
      },
    },
    errors: {
      required: 'Bitte dieses Feld ausfüllen',
      email: 'Bitte eine gültige E-Mail angeben',
      role: 'Bitte eine Option wählen',
      submitFailed: 'Das Formular konnte nicht gesendet werden. Bitte erneut versuchen.',
    },
    sending: 'Wird gesendet…',
    privacyNote:
      'Mit dem Absenden stimmen Sie zu, dass wir diese Daten zur Kontaktaufnahme zu Bringy nutzen. Siehe unsere',
    defaultDescriptions: {
      requestItem: 'Anfrage über Kontaktformular',
      becomeTraveler: 'Reisenden-Registrierung über Kontaktformular',
    },
    requestItem: {
      title: 'Produkt suchen',
      subtitle: 'Sagen Sie uns, was Sie brauchen — wir melden uns innerhalb von 24 Stunden.',
    },
    becomeTraveler: {
      title: 'Als Reisender anbieten',
      subtitle: 'Teilen Sie uns Ihre Route mit — wir melden uns innerhalb von 24 Stunden.',
    },
  },
}
